import { render, staticRenderFns } from "./site-development-who-pays.vue?vue&type=template&id=760ede85"
import script from "./site-development-who-pays.vue?vue&type=script&lang=js"
export * from "./site-development-who-pays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports